import React, { useEffect, useImperativeHandle, useState } from 'react';
import {
  CheckboxChangeEventDetail,
  // IonButton,
  IonCheckbox,
  // IonContent,
  // IonFooter,
  IonItem,
  IonLabel,
  IonList,
  // IonPage,
  // IonSelect,
  // IonSelectOption,
  // IonText,
  // IonToast,
  // IonToolbar,
} from '@ionic/react';
import './SettingsForm.scoped.scss';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../store/store';
import { useSelector } from 'react-redux';
// import {
//   languageOptions,
//   ItemType,
// } from '../../appConfigurations';
import { setParticipant, appSettingsSelector, setAppSettings } from '../../store/slices';
import {
  IonCheckboxCustomEvent /*, IonSelectCustomEvent*/,
} from '@ionic/core/dist/types/components';
// import { SelectChangeEventDetail } from '@ionic/core';

export interface SettingsFormRef {
  onSaveSettings: () => void;
}
export interface SettingsFormProps {
  hideTitle?: boolean;
  disabled?: boolean;
}

const SettingsForm = React.forwardRef<SettingsFormRef, SettingsFormProps>((props, ref) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const {
    /*numberOfTrials: numberOfTrialsStore,
    timeBoxedTrial: timeBoxedTrialStore,
    trialDuration: trialDurationStore,*/
    playSounds: playSoundsStore,
    skipTrial: skipTrialStore,
    language: languageStore,
  } = useSelector(appSettingsSelector);
  /*const [numberOfTrials, setNumberOfTrials] = useState(numberOfTrialsStore);
  const [timeBoxedTrial, setTimeBoxedTrial] = useState(timeBoxedTrialStore);
  const [trialDuration, setTrialDuration] = useState(trialDurationStore);*/
  const [playSounds, setPlaySounds] = useState(playSoundsStore);
  const [skipTrial, setSkipTrial] = useState(skipTrialStore);
  const [language, setLanguage] = useState(languageStore);

  const onSaveSettings = () => {
    dispatch(
      setAppSettings({
        /*numberOfTrials,
        timeBoxedTrial,
        trialDuration,*/
        playSounds,
        skipTrial,
        language,
      })
    );
    dispatch(setParticipant({ play_sounds: playSounds }));
  };

  // The component instance will be extended
  // with whatever you return from the callback passed
  // as the second argument
  useImperativeHandle(ref, () => ({
    onSaveSettings,
  }));

  useEffect(() => {
    /*setNumberOfTrials(numberOfTrialsStore);
    setTimeBoxedTrial(timeBoxedTrialStore);
    setTrialDuration(trialDurationStore);*/
    setPlaySounds(playSoundsStore);
    setSkipTrial(skipTrialStore);
    setLanguage(languageStore);
  }, [
    /*numberOfTrialsStore,
    timeBoxedTrialStore,
    trialDurationStore,*/
    playSoundsStore,
    skipTrialStore,
    languageStore,
  ]);

  return (
    <IonList className="app-settings-wrapper">
      {!props.hideTitle && (
        <>
          <IonItem lines="none" color="none" className="ion-no-padding ion-no-margin">
            <h3 className="page-title">{t('Settings')}</h3>
          </IonItem>
          {/*<IonItem lines="none" color="none" className="ion-no-padding ion-no-margin">*/}
          {/*  <IonText className="subtitle">{t('You can set everything here')}</IonText>*/}
          {/*</IonItem>*/}
        </>
      )}

      {/*<IonItem
            lines="none"
            color="none"
            className="ion-no-padding ion-no-margin settings-label"
          >
            <IonLabel>{t('Number of trials per session')}</IonLabel>
          </IonItem>
          <IonItem
            lines="none"
            color="none"
            className="ion-no-padding ion-no-margin custom-item-select custom-item-select-2"
          >
            <IonSelect
              interface="popover"
              value={numberOfTrials}
              onIonChange={(e: IonSelectCustomEvent<SelectChangeEventDetail>) =>
                setNumberOfTrials(e.detail.value)
              }
              className="select-settings-option"
            >
              {numberOfTrialsOptions?.length &&
                numberOfTrialsOptions.map((item: ItemType) => (
                  <IonSelectOption key={item.id} value={item.option}>
                    {t(item.text)}
                  </IonSelectOption>
                ))}
            </IonSelect>
          </IonItem>
          <hr />
          <IonItem
            lines="none"
            color="none"
            className="ion-no-padding ion-no-margin settings-label item-with-checkbox"
          >
            <IonLabel>{t('Time-boxed trial')}</IonLabel>
            <IonCheckbox
              className="ion-no-margin"
              checked={timeBoxedTrial}
              onIonChange={(e: IonCheckboxCustomEvent<CheckboxChangeEventDetail>) =>
                setTimeBoxedTrial(e.detail.checked)
              }
            />
          </IonItem>
          <hr />
          {timeBoxedTrial && (
            <>
              <IonItem
                lines="none"
                color="none"
                className="ion-no-padding ion-no-margin settings-label"
              >
                <IonLabel>{t('Trial duration')}</IonLabel>
              </IonItem>
              <IonItem lines="none" className="ion-no-padding ion-no-margin custom-item-select">
                <IonSelect
                  interface="popover"
                  value={trialDuration}
                  onIonChange={(e: IonSelectCustomEvent<SelectChangeEventDetail>) =>
                    setTrialDuration(e.detail.value)
                  }
                  className="select-settings-option"
                >
                  {trialDurationOptions?.length &&
                    trialDurationOptions.map((item) => (
                      <IonSelectOption
                        key={item.id}
                        value={item.option}
                        className="select-settings-option"
                      >
                        {item.text}
                      </IonSelectOption>
                    ))}
                </IonSelect>
              </IonItem>
              <hr />
            </>
          )}*/}
      <IonItem
        lines="none"
        color="none"
        className="ion-no-padding ion-no-margin settings-label item-with-checkbox"
      >
        <IonLabel className="settings-label-text">{t('Sounds')}</IonLabel>
        <IonCheckbox
          disabled={props.disabled}
          className="ion-no-margin"
          checked={playSounds}
          onIonChange={(e: IonCheckboxCustomEvent<CheckboxChangeEventDetail>) =>
            setPlaySounds(e.detail.checked)
          }
        />
      </IonItem>
      {/*<hr />*/}
      {/*<IonItem*/}
      {/*  lines="none"*/}
      {/*  color="none"*/}
      {/*  className="ion-no-padding ion-no-margin settings-label item-with-checkbox"*/}
      {/*>*/}
      {/*  <IonLabel className="settings-label-text">{t('Skip trial option')}</IonLabel>*/}
      {/*  <IonCheckbox*/}
      {/*    disabled={props.disabled}*/}
      {/*    className="ion-no-margin"*/}
      {/*    checked={skipTrial}*/}
      {/*    onIonChange={(e: IonCheckboxCustomEvent<CheckboxChangeEventDetail>) =>*/}
      {/*      setSkipTrial(e.detail.checked)*/}
      {/*    }*/}
      {/*  />*/}
      {/*</IonItem>*/}
      {/*<hr />*/}
      {/*<IonItem lines="none" color="none" className="ion-no-padding ion-no-margin settings-label">*/}
      {/*  <IonLabel>{t('Language')}</IonLabel>*/}
      {/*</IonItem>*/}
      {/*<IonItem lines="none" className="ion-no-padding ion-no-margin custom-item-select">*/}
      {/*  <IonSelect*/}
      {/*    disabled={props.disabled}*/}
      {/*    interface="popover"*/}
      {/*    value={language}*/}
      {/*    onIonChange={(e: IonSelectCustomEvent<SelectChangeEventDetail>) =>*/}
      {/*      setLanguage(e.detail.value)*/}
      {/*    }*/}
      {/*    className="select-settings-option"*/}
      {/*  >*/}
      {/*    {languageOptions?.length &&*/}
      {/*      languageOptions.map((item) => (*/}
      {/*        <IonSelectOption key={item.id} value={item.option}>*/}
      {/*          {item.text}*/}
      {/*        </IonSelectOption>*/}
      {/*      ))}*/}
      {/*  </IonSelect>*/}
      {/*</IonItem>*/}
    </IonList>
  );
});

export default SettingsForm;
